import React, { useEffect, useState } from "react";
import { MdCheck, MdClear, MdEdit } from "react-icons/md";
import { HttpData, HttpNoData } from "../../Core";
import IconLoad from '../Main/IconLoad';
import styles from './Profile.module.css';
import { Button, Form, Modal } from "react-bootstrap";

function Profile(props) {

    const [user, setUser] = useState(props.user);
    const [jwt, setJwt] = useState(props.jwt);
    const [property, setProperty] = useState();

    if (user == null)
        return <IconLoad className={styles.load} />;

    const UpdateUser = async (value, successCallback) => {

        const response = await HttpNoData('/api/v0/account/' + property + '?value=' + value, 'PUT', jwt);

        if (response.statusSuccessful) {

            var upadateJWT = jwt;
            if (successCallback != null || successCallback)
                upadateJWT = successCallback(response);

            setUser(await props.updateUser(upadateJWT));
        } else console.log(response.error);
    }

    function FieldEdit(props) {

        const [propertyValue, setPropertyValue] = useState();
        const { propertyName, value, typeInput, successCallback } = props;

        useEffect(() => setPropertyValue(value), []);

        const isCurrentEdit = property == propertyName;

        return <div className={styles.boxEdititonal}>
            <input type={typeInput == null ? 'text' : typeInput} className={styles.blockInput} disabled={!isCurrentEdit} value={isCurrentEdit ? propertyValue : value} onChange={(e) => setPropertyValue(e.target.value)} />
            {
                isCurrentEdit ?
                    <React.Fragment>
                        <MdCheck className={styles.saveIcon} onClick={() => {
                            UpdateUser(propertyValue, successCallback);
                            setProperty('');
                        }} />
                        <MdClear className={styles.cancelIcon} onClick={() => setProperty(null)} />
                    </React.Fragment>
                    :
                    <MdEdit className={styles.editIcon} onClick={() => {
                        setProperty(propertyName);
                    }} />
            }
        </div>
    }

    function FieldReadOnly(props) {

        const { value } = props;
        return <div className={styles.boxEdititonal}>
            <input className={styles.readOnlyInput} disabled={true} defaultValue={value} />
        </div>
    }

    function ContentElement(props) {

        const { name, content } = props;

        if (content == null)
            return null;

        return <div className={styles.contentElement}>
            <label className={styles.titleContentElement}>{name}</label>
            {content}
        </div>
    }

    function Manager(props) {

        const content = <div className={styles.contentNoShadow}>
            <ContentElement name='Имя' content={<FieldEdit propertyName='manager/name' value={user.manager.name} />} />
            <ContentElement name='Доступ' content={<FieldReadOnly value={user.manager.root} />} />
        </div>;

        return content
    }

    function Analytic(props) {

        const content = <div className={styles.contentNoShadow}>
            <ContentElement name='Имя' content={<FieldEdit propertyName='analytic/name' value={user.analytic.name} />} />
            <ContentElement name='Доступ' content={<FieldReadOnly value={user.analytic.root} />} />
        </div>;

        return content
    }
    function Administrator(props) {

        const content = <div className={styles.contentNoShadow}>
            <ContentElement name='Имя' content={<FieldEdit propertyName='administrator/name' value={user.administrator.name} />} />
            <ContentElement name='Доступ' content={<FieldReadOnly value={user.administrator.root} />} />
        </div>;

        return content
    }

    function Worker(props) {

        const [isEditMainPage, setIsEditMainPage] = useState(false);
        const [settingMainPage, setSettingMainPage] = useState({});

        useEffect(() => {

            async function didMount() {

                const responseSettings = await HttpNoData(`api/v1/workers/settingMainPage`, 'GET', jwt);
                setSettingMainPage(responseSettings.data);
            }

            didMount();
        }, []);

        const submitSetting = async (e) => {
            e.preventDefault();

            await HttpData(`api/v1/workers/settingMainPage`, 'PUT', jwt, settingMainPage);
            setIsEditMainPage(false);
        }

        const content = <div className={styles.contentNoShadow}>
            <ContentElement name='Имя' content={<FieldEdit propertyName='worker/name' value={user.worker.name} />} />
            <ContentElement name='Доступ' content={<FieldReadOnly value={user.worker.root} />} />
            <Button variant="success" onClick={() => setIsEditMainPage(true)}>Настройки меню</Button>
            {
                <Modal show={isEditMainPage} onHide={() => setIsEditMainPage(false)}>
                    <Form onSubmit={submitSetting}>
                        <Modal.Header closeButton>
                            <Modal.Title>Главный экран</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label>Следует ли отображать</Form.Label>
                                <Form.Check type="checkbox" label='Штраф' checked={settingMainPage.isPremium} onChange={(e) => setSettingMainPage({ ...settingMainPage, isPremium: e.target.checked })} />
                                <Form.Check type="checkbox" label='Штрафы' checked={settingMainPage.isFines} onChange={(e) => setSettingMainPage({ ...settingMainPage, isFines: e.target.checked })} />
                                <Form.Check type="checkbox" label='Зарплата' checked={settingMainPage.isSalary} onChange={(e) => setSettingMainPage({ ...settingMainPage, isSalary: e.target.checked })} />
                                <Form.Check type="checkbox" label='Норма' checked={settingMainPage.isSalaryBid} onChange={(e) => setSettingMainPage({ ...settingMainPage, isSalaryBid: e.target.checked })} />
                                <Form.Check type="checkbox" label='КПД' checked={settingMainPage.isKpd} onChange={(e) => setSettingMainPage({ ...settingMainPage, isKpd: e.target.checked })} />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setIsEditMainPage(false)}>Отмена</Button>
                            <Button variant="success" type="submit">Сохранить</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
        </div>;

        return content
    }

    function ReplacePassword(props) {

        const [password, setPassword] = useState('');
        const [newPassword, setNewPassword] = useState('');

        const UpdatePassword = async () => {

            const response = await HttpNoData('/api/v0/account/password?oldPassword=' + password + '&newPassword=' + newPassword, 'PUT', jwt);

            if (response.statusSuccessful) {
                setPassword('');
                setNewPassword('');
                alert('Пароль успешно обновлен');
            }
            else alert('Текущий пароль неверный!');
        }

        return <div className={styles.contentNoShadow}>
            <ContentElement name='Старый пароль' content={<input type='password' className={styles.password} value={password} onChange={(e) => setPassword(e.target.value)} />} />
            <ContentElement name='Новый пароль' content={<input type='password' className={styles.password} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />} />
            <button className={styles.savePassword} disabled={password == '' || newPassword == ''} onClick={UpdatePassword}>сохранить</button>
        </div>
    }

    const Telegram = () => {

        return user.telegram ?
            <FieldReadOnly value={'@' + user.telegram.username} />
            : <FieldReadOnly value='Подключение отключено' />
    }

    return <div className={styles.psevdoBody}>
        <div className={styles.content}>
            <ContentElement name='Имя' content={<FieldEdit propertyName='name' value={user.name} />} />
            <ContentElement name='Логин' content={<FieldEdit propertyName='login' value={user.login} successCallback={(response) => {
                props.updateJwt(response.data);
                setJwt(response.data);
                return response.data;
            }} />} />
            <ContentElement name='Сменить пароль' content={<ReplacePassword />} />
            <ContentElement name='Менеджер' content={user.manager == null ? null : <Manager />} />
            <ContentElement name='Производственный специалист' content={user.worker == null ? null : <Worker />} />
            <ContentElement name='Аналитик' content={user.analytic == null ? null : <Analytic />} />
            <ContentElement name='Администратор' content={user.administrator == null ? null : <Administrator />} />
            <ContentElement name='Сторонние сервисы' content={
                <div className={styles.contentNoShadow}>
                    <ContentElement name='Telegram' content={<Telegram />} />
                </div>
            } />
        </div>
    </div>
}

export default Profile;
